import BookingTable from "components/Booking/BookingTable";
import React, { Component } from "react";

export default class BookingTableContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        vendor_id: "",
        station_id: "",
        model_id: "",
        manufacturer_id: "",
        filter_date: "",
        status: "",
        from_date: "",
        to_date: "",
        fromat_date_from: "",
        fromat_date_to: "",
      },
      formError: {
        vendor_id: false,
        station_id: false,
        model_id: false,
        manufacturer_id: false,
        filter_date: false,
        status: false,
      },
      ErrorMsg: "",
      datePickerOpen: false,
    };
  }
  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };

  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };

  async componentDidMount() {
    await this.handleFilterApiData();
    this.getCommonData();

    const model_id1 = this.state.formData.manufacturer_id;
    await this.props.getManufacturerAction();
    await this.props.getVehiclesMasterAction(model_id1);
    await this.props.getVendorNameDataAction();
    const vendor_id1 = this.state.formData.vendor_id;
    this.props.getLocationAction(vendor_id1);
  }

  handleFilterApiData = async () => {
    await this.props.getBookingAction({
      status: this.state.formData.status,
      vendor_id: this.state.formData.vendor_id,
      model_id: this.state.formData.model_id,
      station_id: this.state.formData.station_id,
      manufacturer_id: this.state.formData.manufacturer_id,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
    });
  };
  handleReset = async () =>{
    await this.props.getBookingAction({
      status: this.state.formData.status,
      vendor_id: this.state.formData.vendor_id,
      model_id: this.state.formData.model_id,
      station_id: this.state.formData.station_id,
      manufacturer_id: this.state.formData.manufacturer_id,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
    });
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }

  getCommonData = () => {
    this.props.getVehiclesMasterAction();
    this.props.getLocationAction();
    this.props.getManufacturerAction();
    this.props.getVendorNameDataAction();
  };

  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    // this.handleFilterApiData();
    this.setState({ formData });

    const model_id1 = this.state.formData.manufacturer_id;
    this.props.getVehiclesMasterAction(model_id1);

    const vendor_id1 = this.state.formData.vendor_id;
    this.props.getLocationAction(vendor_id1);
  };

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }

  render() {
    return (
      <>
        <BookingTable
          onDatePickerSub={this.onDatePickerSub}
          props={this.props}
          formData={this.state.formData}
          formError={this.state.formError}
          isLoading={this.props.isLoading}
          isError={this.state.ErrorMsg}
          onChange={this.handleChange}
          datePickerOpen={this.state.datePickerOpen}
          handleDatePickerOpen={this.handleDatePickerOpen}
          handleDatePickerClose={this.handleDatePickerClose}
          from_date={this.state.formData.from_date}
          to_date={this.state.formData.to_date}
          fromat_date_from={this.state.formData.fromat_date_from}
          fromat_date_to={this.state.formData.fromat_date_to}
          handleReset={this.handleReset}
        />
      </>
    );
  }
}
